/**
 * 外壳（2026-09-19 按 www.godepth.top 重构）：网格底 + 居中悬浮药丸导航 + 页内目录条 + 面包屑。
 *
 * 不再有切页动画（旧 PageTransition 至少 0.5s）；懒加载超过 300ms 才出现一条 1px 进度线。
 */
import { Suspense, useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Breadcrumb } from './Breadcrumb';
import { CommandPalette } from './CommandPalette';
import { GridBackground } from './GridBackground';
import { MobileBar } from './MobileBar';
import { SectionStrip } from './SectionStrip';
import { MobileTop, TopNav } from './TopNav';
import { useShellHotkeys } from './use-shell-hotkeys';

function RouteProgress() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const t = window.setTimeout(() => setShow(true), 300);
    return () => window.clearTimeout(t);
  }, []);
  if (!show) return null;
  return <div className="fixed inset-x-0 top-0 z-[60] h-0.5 animate-pulse bg-gradient-to-r from-sky-500 to-teal-500" aria-label="页面加载中" />;
}

export function AppShell() {
  const { pathname } = useLocation();
  useShellHotkeys();

  // 切页回到顶部（旧外壳由 PageTransition 的重新挂载顺带完成）
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="relative min-h-screen bg-background text-foreground">
      <GridBackground />
      <TopNav />
      <MobileTop />
      <SectionStrip />
      <main className="relative z-10 pt-20 md:pt-24">
        {/* 桌面内容占80%，两侧留出可滚动留白；小屏保留紧凑边距。 */}
        <div className="w-full min-w-0 px-3 pb-24 sm:px-4 lg:px-[10%] md:pb-10">
          <Breadcrumb />
          <Suspense fallback={<RouteProgress />}>
            <Outlet />
          </Suspense>
        </div>
      </main>
      <MobileBar />
      <CommandPalette />
    </div>
  );
}
